import React, { Component, useEffect, useState } from 'react';
import { Constants } from '../../Constants';
import authService from '../api-authorization/AuthorizeService'

const PricingTable = (props) => {

	const [prices, updatePrices] = useState();
	const [loading, updateLoading] = useState(true);

	useEffect(() => {
		if(!props.priceCheckCompleted){
			getPrices();
		}
	}); // Whenever input props change, refetch the prices for it?

	const getPrices = async () =>{
		const token = await authService.getAccessToken();
		// Controllers\PriceCheckController.cs > public async Task<IEnumerable<RoutePricingViewDto>> getPrices
		var queryString = "?type=" + props.type 
			+ "&loadingCityName=" + props.loadingCityName 
			+ "&loadingStateName=" + props.loadingStateName
			+ "&loadingZipCode=" + props.loadingZipCode
			+ "&deliveryCityName=" + props.deliveryCityName
			+ "&deliveryStateName=" + props.deliveryStateName
			+ "&deliveryZipCode=" + props.deliveryZipCode

		props.setPriceCheckComplete(true);

		const response = await fetch('PriceCheck/getPrices?' + queryString, {
		headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
		});
		const data = await response.json();
		updatePrices(data);
		updateLoading(false);
	}

	return(
		<div>
			{!loading 
			&& 
			<table className='table table-striped' aria-labelledby="tabelLabel">
				<thead>
				<tr>
					<th>Route</th>
					<th>Price paid</th>
					<th>Cargo description</th>
					<th>Estimate type</th>
				</tr>
				</thead>
				<tbody>
				{prices.map((routePrice,index) =>
					<tr key={index}>
						{/* Models\RoutePricing.cs > RoutePricingViewDto */}
						<td>{routePrice.loadingAddress}<i class="fa fa-arrow-right"></i>{routePrice.deliveryAddress}&nbsp;({Number(routePrice.distanceInMiles).toFixed(2)} miles)</td>
						<td>{Number(routePrice.pricePaid).toFixed(2)}&nbsp;(${Number(routePrice.pricePaid/routePrice.distanceInMiles).toFixed(2)} per mile)</td>
						<td>{routePrice.cargoDescription}</td>
						<td>{routePrice.pricingType}</td>
					</tr>
				)}
				</tbody>
			</table>
			}
			{loading && <h4>Loading...</h4>}
		</div>
	);

}

export { PricingTable as PricingTable };